export default interface IMessage {
	message: string,
	shortLink: boolean,
}

export const defaultMessage: IMessage = {
	message: "",
	shortLink: true,
}
